export const LINK_EXPIRY_MS = 3 * 60 * 1000;
export const SESSION_TTL_DAYS = 7;
export const DEFAULT_CONFIDENCE_THRESHOLD = 80;
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
